import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";

export default class extends Controller {
    static targets = ["type", "optionsSection", "list", "template"]
    static optionTypes = ["dropdown", "multi_select"]

    connect() {
        this.sortable = Sortable.create(this.listTarget, {
            handle: ".drag-handle",
            animation: 150
        })
        this.toggleOptions()
    }

    disconnect() {
        this.sortable.destroy()
    }

    toggleOptions() {
        const usesOptions = this.constructor.optionTypes.includes(this.typeTarget.value)
        this.optionsSectionTarget.classList.toggle("hidden", !usesOptions)

        if (usesOptions && this.visibleRows().length === 0) {
            this.addOption()
        }
    }

    addOption() {
        const key = `${Date.now()}${Math.floor(Math.random() * 1000)}`
        const html = this.templateTarget.innerHTML.replace(/NEW_KEY/g, key)
        this.listTarget.insertAdjacentHTML("beforeend", html)

        const input = this.listTarget.lastElementChild.querySelector("input[type='text']")
        if (input) {
            input.focus()
        }
    }

    // Saved options are hidden and flagged so the server can archive them; rows
    // that were never saved are simply dropped.
    removeOption(event) {
        const row = event.target.closest("[data-option-row]")
        const idField = row.querySelector("input[name$='[id]']")

        if (idField) {
            row.querySelector("[data-removed-field]").value = "1"
            row.classList.add("hidden")
        } else {
            row.remove()
        }
    }

    visibleRows() {
        return Array.from(this.listTarget.querySelectorAll("[data-option-row]")).filter((row) => {
            return !row.classList.contains("hidden")
        })
    }
}
